/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Contact_Panel_DescriptionInputs */

const en_directory_resources_contact_panel_description = /** @type {(inputs: Directory_Resources_Contact_Panel_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us what you are working on and include the relevant product or campaign link.`)
};

const zh_directory_resources_contact_panel_description = /** @type {(inputs: Directory_Resources_Contact_Panel_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请说明你正在推进的事项，并附上相关产品或活动链接。`)
};

/**
* | output |
* | --- |
* | "Tell us what you are working on and include the relevant product or campaign link." |
*
* @param {Directory_Resources_Contact_Panel_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_contact_panel_description = /** @type {((inputs?: Directory_Resources_Contact_Panel_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Contact_Panel_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_contact_panel_description(inputs)
	return zh_directory_resources_contact_panel_description(inputs)
});
export { directory_resources_contact_panel_description as "directory.resources.contact_panel.description" }